const styles = {
  paddingX: "md:px-16 px-6",
  paddingY: "sm:py-8 md:py-16 py-6",
  padding: "sm:px-8 md:px-16 px-6 sm:py-8 md:py-16 py-10",

  heroHeadText:
    "font-black text-txt-primary lg:text-[80px] sm:text-[60px] xs:text-[50px] text-[40px] lg:leading-[98px] mt-2",
  heroSubText:
    "text-txt-secondary font-medium lg:text-[30px] sm:text-[26px] xs:text-[20px] text-[18px] lg:leading-[40px]",

  sectionHeadText:
    "text-txt-primary font-semibold md:text-[50px] text-[40px]",
  sectionSubText:
    "sm:text-[18px] text-[14px] text-secondary uppercase tracking-wider",
};

export { styles };
